import React, { useState } from "react";
import config from "../../../config";
import ApiDropdown from "../../DropDown/Apidropdown";
import Input from "../../input/input";
import "../Modal2.css";
import { authFetch } from "../../../utils/Security/authFetch";

type ConfirmCloseModalProps = {
  data: any; // Should ideally be typed better
  onConfirm: () => void; // Callback on success
  onCancel: () => void;
};

const ChangePhaseModel: React.FC<ConfirmCloseModalProps> = ({
  data,
  onConfirm,
  onCancel,
}) => {
  const [phase, setPhase] = useState<string>(data.phase || "");

  const handleConfirm = async () => {
    if (!phase) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      const params = new URLSearchParams({
        phase,
      });

      const url = `${config.apiBaseUrl}/api/changes/changephase/${
        data.ticketId
      }?${params.toString()}`;

      const response = await authFetch(url, {
        method: "PUT",
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Error: ${response.status} - ${text}`);
      }

      alert("Change Phase successfully!");
      onConfirm();
      window.location.reload();
    } catch (error) {
      alert(`Failed to change phase: ${(error as Error).message}`);
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,

        padding: "1rem",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#fff",
          padding: "2rem 2.5rem",
          borderRadius: "12px",
          maxWidth: 450,
          height: "400px",
          width: "100%",
          boxShadow:
            "0 8px 24px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontWeight: "600",
            fontSize: "1.5rem",
            color: "#333",
          }}
        >
          Confirm Phase Change
        </h2>

        <ApiDropdown
          api="ChangePhases"
          required
          labelKey="name"
          valueKey="name"
          label="Status"
          value={phase}
          onChange={(val) => setPhase(String(val))}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "0.5rem 1.2rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              color: "#444",
              cursor: "pointer",
              fontWeight: 500,
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#f0f0f0")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#fff")
            }
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#f97316",
              color: "white",
              cursor: "pointer",
              fontWeight: 600,
              boxShadow: "0 4px 8px rgba(249, 115, 22, 0.4)",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#c4510b")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#f97316")
            }
          >
            Yes, Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePhaseModel;
